import React, { Component } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import Price from "components/Price/Price";
import * as PropTypes from "prop-types";

export class OrderPreviewRow extends Component {
  render() {
    let { order, path } = this.props;
    const orderDate = moment(order.register).format("DD.MM.YYYY")
    const orderLink = `${path}/${order.map_id}`
    const isSuccess = (order.status === 2)
    return (
      <tr>
        <td>
          <Link to={orderLink}>
            #{order.map_id} {order.comment ? `- ${order.comment}` : ""}
          </Link>
        </td>
        <td className="tr"><Price>{order.netto}</Price></td>
        <td className="tc">{order.positions.length}</td>
        <td className="tc">{orderDate}</td>
      </tr>
    )
  }
}

OrderPreviewRow.propTypes = {
  order: PropTypes.any,
  path: PropTypes.any
}


// WEBPACK FOOTER //
// ./src/theme/hobbyfun/components/OrderTable/OrderPreviewRow.js